import Head from 'next/head'
import { WEBSITE, MAIN_SITE_IMAGE, SITENAME } from 'src/consts'
import { intl } from 'src/i18n'

export const Meta = () => {
  const title = intl.t('globalCharts.meta.title')
  const description = intl.t('globalCharts.meta.description')

  const uri = '/charts'
  const url = `${WEBSITE}${uri}`

  const schemaJson = {
    '@context': 'http://schema.org',
    '@type': 'WebPage',
    name: '${title}',
    description: '${description}',
    url: '${url}',
    image: '${MAIN_SITE_IMAGE}',
    sameAs: ['https://twitter.com/coin360com'],
  }

  return (
    <Head>
      <title id='Main-Title'>{title}</title>
      <meta id='Main-Description' name='description' content={description} />
      <meta id='Main-Image' name='image' content={MAIN_SITE_IMAGE} />
      <meta id='OpenGraph-Title' property='og:title' content={title} />
      <meta id='OpenGraph-URL' property='og:url' content={url} />
      <meta
        id='OpenGraph-Image'
        property='og:image'
        content={MAIN_SITE_IMAGE}
      />
      <meta property='og:image:type' content='image/png' />
      <meta property='og:image:width' content='600' />
      <meta property='og:image:height' content='315' />
      <meta id='OpenGraph-SiteName' property='og:site_name' content='COIN360' />
      <meta
        id='OpenGraph-Description'
        property='og:description'
        content={description}
      />
      <meta id='OpenGraph-Type' property='og:type' content='website' />
      <meta
        id='Twitter-card'
        name='twitter:card'
        content='summary_large_image'
      />
      <meta id='Twitter-Title' name='twitter:title' content={title} />
      <meta id='Twitter-Title' name='twitter:text:title' content={title} />
      <meta
        id='Twitter-Description'
        name='twitter:text:title'
        content={title}
      />
      <meta id='Twitter-Image' name='twitter:image' content={MAIN_SITE_IMAGE} />
      <link rel='canonical' href={`https://${SITENAME}${uri}`} />
      <script
        type='application/ld+json'
        id='Main-Script'
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaJson) }}
      />
    </Head>
  )
}

export default Meta
